<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-12 16:19:49
-->
<template>
	<div class="yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="标签名称" class="form-item">
				<el-input v-model="formData['tags_name']" placeholder="请输入标签名称"></el-input>
			</el-form-item>
			<el-form-item style="margin-left: 24px" class="form-item">
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
export default {
	name: 'search',
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {
			formData: {},
		};
	},
	methods: {
		onClear() {
			this.formData = {};
			this.onSubmit();
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>
<style lang='less' scoped>
.form-item{
	margin-bottom: 0px !important;
}
</style>
